module.exports = __webpack_public_path__ + "img/ad2.4b6ff6c0.jpg";